import * as React from "react";
import { Box, Typography } from "@mui/material";

interface CustomInputProps {
  value: string | number;
  onChange: (value: string | number | React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: "text" | "number" | "email" | "tel" | "date" | "datetime-local";
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  onPrefixClick?: () => void;
  onSuffixClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  name?: string;
}

export default function CustomInput({
  value,
  onChange,
  placeholder = "Enter value...",
  type = "text",
  prefixIcon,
  suffixIcon,
  onPrefixClick,
  onSuffixClick,
  disabled = false,
  fullWidth = false,
  error = false,
  helperText,
  onBlur,
  name,
}: CustomInputProps) {
  const [isFocused, setIsFocused] = React.useState(false);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  return (
    <Box sx={{ width: fullWidth ? "100%" : "auto" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "6px 12px",
          border: isFocused ? (error ? "2px solid #dc2626" : "1px solid #212529") : (error ? "2px solid #dc2626" : "1px solid #d1d5db"),
          borderRadius: "6px",
          backgroundColor: disabled ? "#f3f4f6" : "#ffffff",
          transition: "border-color 0.2s",
        }}
      >
        {prefixIcon && (
          <Box onClick={onPrefixClick} sx={{ display: "flex", alignItems: "center", mr: 1, cursor: onPrefixClick ? "pointer" : "default", color: "#6b7280" }}>
            {prefixIcon}
          </Box>
        )}
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={() => setIsFocused(true)}
          onBlur={handleBlur}
          name={name}
          style={{ flex: 1, border: "none", outline: "none", background: "transparent", fontSize: "0.875rem", color: "#212529", width: "100%" }}
        />
        {suffixIcon && (
          <Box onClick={onSuffixClick} sx={{ display: "flex", alignItems: "center", ml: 1, cursor: onSuffixClick ? "pointer" : "default", color: "#6b7280" }}>
            {suffixIcon}
          </Box>
        )}
      </Box>
      {helperText && (
        <Typography variant="caption" sx={{ mt: 0.5, color: error ? "#dc2626" : "#6b7280", fontSize: "0.75rem" }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
}
